module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-24.a99f9cce.png";